@if (dataVisible$ | async) {
  @if(calculateBelastbaarloon() !== 0) {
    <form [formGroup]="formGroup">
      <div>
        <div class="row">
          <div class="col col-1">
            Inkomsten uit loondienst
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control
              [decimals]="0"
              align="right"
              class="custom-input-150"
              formControlName="loonUitTegenwoordigeDienstbetrekking"
              id="loonUitTegenwoordigeDienstbetrekking"
              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
          <div class="col-4"></div>
        </div>
      </div>
      @if ((incomeTaxEntity$ | async)?.taxType === 'DA') {
        @if (formGroup.controls.reisaftrekOpenbaarVervoer.value !== null) {
          <div class="row">
            <div class="col col-1">
              Af: Reisaftrek openbaar vervoer
            </div>

            <div class="col-2">
              <snelstart-ui-number-form-control
                [decimals]="0"
                align="right"
                class="custom-input-150"
                formControlName="reisaftrekOpenbaarVervoer"
                id="reisaftrekOpenbaarVervoer"
                prefix="€ -"
              ></snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
          </div>
        }
        @if (formGroup.controls.vergoedingReisaftrek.value !== null) {
          <div class="row">
            <div class="col col-1">
              Bij: Vergoeding werkgever openbaar vervoer
            </div>

            <div class="col-2">
              <snelstart-ui-number-form-control
                [decimals]="0"
                align="right"
                class="custom-input-150"
                formControlName="vergoedingReisaftrek"
                id="vergoedingReisaftrek"
                prefix="€"
              ></snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
            <div class="col-4"></div>
          </div>
        }
      }
      @if (formGroup.controls.loonUitVroegereDienstbetrekking.value !== null) {
        <div class="row">
          <div class="col col-1">
            Pensioen en andere uitkeringen
          </div>

          <div class="col-2">
            <snelstart-ui-number-form-control
              [decimals]="0"
              align="right"
              class="custom-input-150"
              formControlName="loonUitVroegereDienstbetrekking"
              id="loonUitVroegereDienstbetrekking"
              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
          <div class="col-4"></div>
        </div>
      }
      @if (formGroup.controls.loonUitTegenwoordigeDienstbetrekkingBuitenland.value !== null) {
        <div class="row">
          <div class="col col-1">
            Loon uit buitenlandse dienstbetrekking (tegenw.)
          </div>

          <div class="col-2">
            <snelstart-ui-number-form-control
              [decimals]="0"
              align="right"
              class="custom-input-150"
              formControlName="loonUitTegenwoordigeDienstbetrekkingBuitenland"
              id="loonUitTegenwoordigeDienstbetrekkingBuitenland"
              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
          <div class="col-4"></div>
        </div>
      }
      @if (formGroup.controls.loonUitVroegereDienstbetrekkingBuitenland.value !== null) {
        <div class="row">
          <div class="col col-1">
            Loon uit buitenlandse dienstbetrekking (vroeger)
          </div>

          <div class="col-2">
            <snelstart-ui-number-form-control
              [decimals]="0"
              align="right"
              class="custom-input-150"
              formControlName="loonUitVroegereDienstbetrekkingBuitenland"
              id="loonUitVroegereDienstbetrekkingBuitenland"
              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
          <div class="col-4"></div>
        </div>
      }
      @if (formGroup.controls.loonUitTegenwoordigeDienstbetrekkingInternationaleOrganisatie.value !== null) {
        <div class="row">
          <div class="col col-1">
            Vrijgesteld loon uit internationale organisatie (tegenw.)
          </div>

          <div class="col-2">
            <snelstart-ui-number-form-control
              [decimals]="0"
              align="right"
              class="custom-input-150"
              formControlName="loonUitTegenwoordigeDienstbetrekkingInternationaleOrganisatie"
              id="loonUitTegenwoordigeDienstbetrekkingInternationaleOrganisatie"
              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
          <div class="col-4"></div>
        </div>
      }
      @if (formGroup.controls.loonUitVroegereDienstbetrekkingInternationaleOrganisatie.value !== null) {
        <div class="row">
          <div class="col col-1">
            Vrijgesteld loon uit internationale organisatie (vroeger)
          </div>

          <div class="col-2">
            <snelstart-ui-number-form-control
              [decimals]="0"
              align="right"
              class="custom-input-150"
              formControlName="loonUitVroegereDienstbetrekkingInternationaleOrganisatie"
              id="loonUitVroegereDienstbetrekkingInternationaleOrganisatie"
              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
          <div class="col-4"></div>
        </div>
      }
      <div class="row">
        <div class="col col-1">
          <p><b>Totaal loon</b></p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="custom-input-150"
            [calculate]="calculateBelastbaarloon()"
            formControlName="belastbaarloon"
            id="belastbaarloon"
            placeholder="-"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    </form>
  } @else {
    <p>Er is geen loon uit dienstbetrekking in de aangifte ingevuld.</p>
  }
}
